// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2n0Yo","colCheckbox":"styles_colCheckbox__WWZjp"};